import React from "react";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { SiLeetcode, SiGeeksforgeeks } from "react-icons/si";
import "./Sidebar.css";

function Sidebar() {
  return (
    <div className="sidebar">
      <ul className="icon-list">
        <li>
          <a
            href="https://github.com/vikasp07"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub />
          </a>
        </li>
        <li>
          <a
            href="https://linkedin.com/in/vikasmpawar"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
        </li>
        <li>
          <a
            href="https://leetcode.com/u/vikasmp/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiLeetcode />
          </a>
        </li>
        <li>
          <a
            href="https://www.geeksforgeeks.org/user/vikasmp7smu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiGeeksforgeeks />
          </a>
        </li>
      </ul>
      <div className="vertical-line"></div>
    </div>
  );
}

export default Sidebar;
